class exports.ZonesDialogHandler extends FullPageHandler

    init: () ->
        @ppID = parseInt $(@parent.layoutSelector).find('#sel_sz_pp').val()

        @layoutUrl = 'backend/portal/zones/zones/load-layout'
        @loadLayoutPostOptions ?= {}
        @loadLayoutPostOptions.pp_id = @ppID

        @subHandlers =
            'AddEdit':
                'class': 'portal::handlers/zones/AddEditDialog'
            'AddEditWithIrr':
                'class': 'portal::handlers/zones/AddEditDialogWithIrr'
            'AddEditWithGrower':
                'class': 'portal::handlers/zones/AddEditDialogWithGrower'
            'ZoneDelete':
                'class': 'portal::handlers/zones/ZonesDeleteDialogHandler'

        @createDialog()


    afterLoadLayout: (selector, response) ->
        @openDialog()

        if response.status?.type isnt 'success'
            return

        self = this

        # determine which form of the add/edit dialog to use
        switch response.data?.add_edit_handler
            when 'with_grower'
                @addEditHandler = 'AddEditWithGrower'
            when 'with_irr'
                @addEditHandler = 'AddEditWithIrr'
            else
                @addEditHandler = 'AddEdit'

        @dialog.find('.zones-container').on 'click', '.btn-zone-edit', null, () ->
            btn = $(this)
            id = btn.data 'zone-id'
            self.addEditZone id

        @dialog.find('.zones-container').on 'click', '.btn-zone-delete', null, () ->
            id = $(this).data 'zone-id'
            self.deleteZone id


        size = @dialog.find('.modal-body').height() - 35
        @table = @dialog.find('.table').dataTable
            'sScrollY': size + 'px'
            'bPaginate': false
            'bFilter': false
            'bInfo': false
            'bSort': false
            'aaSorting': []

        # I don't completely understand how this works - something with event
        # timing is weird. Without the timeout, the Territories and Zones lists
        # aren't visible after you switch tabs. And for some reason, adding it
        # for Zones makes both Zones and Territories work. That's all I know.
        # If you really want to know, maybe you should ask Tim.
        # -SK
        # setTimeout ()=>
        #     @handleResize()
        # ,150

        $(window).unbind('modal_resized').bind 'modal_resized', debounce (e) =>
            if @table?.fnSettings()?
                size = @dialog.find('.modal-body').height() - 35
                @table.fnSettings().sY = "#{size}px"
                @dialog.find('.dataTables_scrollBody').height(size)
                @table.fnAdjustColumnSizing()


    addEditZone: (id = null) ->
        handler = @createSubHandler(@addEditHandler)

        if handler
            if id?
                handler.loadLayoutPostOptions =
                    sz_id: id
            handler.init()


    deleteZone: (id) ->
        handler = @createSubHandler('ZoneDelete')
        if handler
            handler.loadLayoutPostOptions =
                sz_id: id
            handler.init()
